<template>
    <div class="filter">
        <i class="fa fa-search"></i>
        <input type="text" v-model="Ifilter" :placeholder="$t('global.filter')" debounce="500"/>
        <i class="zmdi zmdi-close" :class="{show:Ifilter.length > 0}" @click.stop="clearFilter"></i>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        name: 'filter-component',
        props: ['filter'],
        data: () => ({
            Ifilter: ''
        }),
        watch: {
            Ifilter: function (value) {
                this.emitFilter(value);
            }
        },
        methods: {
            emitFilter: debounce(function (value) {
                this.$emit('filter',value);
            }, 500),

            clearFilter: function(){
                this.Ifilter = '';
            }
        }
    }
</script>
